import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from "../../components/common/AppDataGrid";


const Payrolldepartment = () => {
    const [departments, setDepartment] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
    const [form, setForm] = useState({
        dept_id: "",
        dept_name: "",
        school_id: "",
        is_active: "",
    });

    const handleEditClick = (dept_id) => {
        const departmentToEdit = departments.find(department => department.dept_id === dept_id);
        console.log(departmentToEdit);
        if (departmentToEdit) {
            navigate("/addpayrolldepartment", { state: { departmentData: departmentToEdit } });
        } else {
            console.error("ID ${ dept_id } not found");
        }
    };
    useEffect(() => {
        setIsLoading(true);
        fetchDepartment().finally(() => setIsLoading(false));
    }, []);


    const fetchDepartment = async () => {
        try {
            const response = await axios.post(baseUrl + "/departmentread/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setDepartment(response.data);
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching department:", error);
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    //  const formatTime12Hour = (time) => {
    //     if (!time) return ''; 
    //     if (/^\d{1,2}:\d{2} (AM|PM)$/.test(time)) {
    //         return time;  
    //     }
    //     const [hoursStr, minutesStr] = time.split(':');
    //     if (!hoursStr || !minutesStr) return 'No Records Found'; 
    //     let hours = parseInt(hoursStr, 10);
    //     const minutes = minutesStr.padStart(2, '0');
    //     if (isNaN(hours) || isNaN(minutes)) return 'No Records Found';
    //     const amPm = hours >= 12 ? 'PM' : 'AM';
    //     hours = hours % 12 || 12;
    //     return `${hours}:${minutes} ${amPm}`;
    // };

    const columns = [
        {
            field: "dept_name",
            headerName: "Department Name",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        ...(canSubmit
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    flex: 1,
                    sortable: false,
                    renderCell: (params) =>
                        params.row.dept_id !== "No records found" ? (
                            <div className="tableActions">
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.dept_id)}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>
                                <Tooltip title="Delete" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleDeleteClick(params.row.dept_id)}
                                    >
                                        <MdDelete />
                                    </span>
                                </Tooltip>
                            </div>
                        ) : null,
                },
            ]
            : []),
    ];

    const handleDeleteClick = async (dept_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');
        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            dept_id: dept_id,
            action: "DELETE"
        };
        try {
            const response = await axios.post(baseUrl + '/payrolldepartmentmaster/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set to InActive");
            fetchDepartment();
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const searchableColumns = [
        (row) => row.dept_name,
    ];

    const filteredRecords = (departments || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const [filter, setFilter] = useState({
        dept_id: "",
        dept_name: "",
        action: "FILTER"
    });


    // const handleFilterSubmit = async (e) => {
    //     e.preventDefault();
    //     const formData = {
    //         role_name: filter.role_name || "",
    //         action: "FILTER",
    //     };

    //     try {
    //         const response = await axios.post(baseUrl + "/role/", formData, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //         });

    //         const dataArray = Array.isArray(response.data) ? response.data : [];
    //         setRoles(dataArray);

    //         setFilter((prevFilter) => ({
    //             ...prevFilter,
    //         }));
    //         setShowFilterModal(false);

    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            dept_name: "",
        });
        setShowFilterModal(true);
        fetchDepartment();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (


        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Department Master</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addpayrolldepartment")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={
                                Array.isArray(filteredRecords) && filteredRecords.length > 0
                                    ? filteredRecords
                                    : [{ dept_id: "No records found" }]
                            }
                            columns={columns}
                            getRowId={(row) => row.dept_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={550}
                        />

                    )}
                </div>
            </div>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="shift_from_time">
                                    <Form.Label>Shift Name </Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="shift_name"
                                        value={filter.shift_name}
                                        placeholder='Enter Shift Name'
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="shift_from_time">
                                    <Form.Label>Shift From Time </Form.Label>
                                    <Form.Control
                                        type="time"
                                        id="shift_from_time"
                                        value={filter.shift_from_time}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFilter({ ...filter, shift_from_time: value });
                                        }}
                                    />
                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="shift_to_time">
                                    <Form.Label>Shift To Time </Form.Label>
                                    <Form.Control
                                        type="time"
                                        id="shift_to_time"
                                        value={filter.shift_to_time}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFilter({ ...filter, shift_to_time: value });
                                        }}

                                    />
                                </Form.Group>
                            </div>
                        </Col>

                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="btn-success primaryBtn">
                            Search
                        </Button></div>
                </Modal.Footer>

            </Modal>
        </div>
    );
};

export default Payrolldepartment;
